import type { TControlActionFunction, TActionParams, IEventInfo } from '../models';

interface IAddPropsToFunction {
    /** Функций */
    callback: TControlActionFunction;
    /** Параметры */
    props: TActionParams;
}

/** Добавить параметры к функции */
export const addPropsToFunction =
    ({ callback, props }: IAddPropsToFunction) =>
    (events?: IEventInfo) =>
        callback({ ...props, ...events });
